<template>
  <div class="tei-scoring-bar">
    <div class="tei-scoring-bar__response-pills">
      <span
        v-if="showScore"
        class="tei-scoring-bar__response-pill"
      >
        {{ $t('Points:') }}
        {{ score }}
      </span>
      <span
        v-if="showTries && maxAttempts && (showAnswerKey || (attempts && userIsStudent))"
        class="tei-scoring-bar__response-pill"
      >
        {{ $t('Tries:') }}

        <!-- For the answer key, show the max tries -->
        <template v-if="showAnswerKey">
          {{ maxAttempts }}
        </template>

        <!-- When making an attempt, show the attempt count as well -->
        <template v-else>
          {{ attempts }}/{{ maxAttempts }}
        </template>
      </span>
      <span v-if="!userIsStudent && !studentView">
        <TEIStartOverButton
          :small="true"
          v-if="hasTries()"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import TEIStartOverButton from '@/components/teis/TEIStartOverButton.vue';
import {
  useAssessmentStore,
  useEditorStore,
  useUserStore,
} from '@/stores';

export default {
  components: {
    TEIStartOverButton,
  },
  props: {
    maxAttempts: {
      type: Number,
      default: 0,
    },
    attempts: {
      type: Number,
      default: 0,
    },
    score: {
      type: Number,
      default: 0,
    },
    showAnswerKey: {
      type: Boolean,
      default: false,
    },
    showScore: {
      type: Boolean,
      default: true,
    },
    showTries: {
      type: Boolean,
      default: true,
    },
    assetId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState(useUserStore, [
      'userIsStudent',
    ]),
    ...mapState(useAssessmentStore, [
      'attemptItemByTeiId',
    ]),
    ...mapState(useEditorStore, [
      'studentView',
    ]),
  },
  methods: {
    hasTries() {
      if (this.assetId) {
        // grab the attemptItem
        const item = this.attemptItemByTeiId(this.assetId);

        // no try object, or tries is 0?
        if (item) {
          return item.try?.tries;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="stylus">
.tei-scoring-bar {
  display: flex;
  min-height: $nebula-space-7x;
  width: 100%;

  &__response-pills {
    background: $nebula-color-white;
    display: flex;
    gap: $nebula-space-2x;
    padding: $nebula-space-1x $nebula-space-3x;
    width: 100%;
  }

  &__response-pill {
    background-color: $nebula-color-platform-interface-200;
    border-radius: 100px;
    padding: $nebula-space-1x $nebula-space-2x;
  }
}
</style>
